<template>
  <div v-if="isUpdate" class="update-tips__mask">
    <div class="update-tips">
      <div class="update-tips__title">升级维护公告</div>
      <div class="update-tips__content">
        <p class="update-tips__memo">
          {{ memo }}
        </p>
        <div class="update-tips__warnning">
          {{ tips }}
        </div>
        <div class="update-tips__button" @click="handleConfirm">确定</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  memo: {
    type: String,
    default: '亲爱的用户，为了更好的助力您使用 AI 销售助理，我们将优化并修复部分功能。'
  },
  tips: {
    type: String,
    default: '在此期间，请尽量不要使用系统，给您带来的不便敬请谅解。'
  },
  onConfirm: {
    type: Function,
    default: null
  }
})

const isUpdate = ref(true)

const handleConfirm = () => {
  isUpdate.value = false

  // 调用传入的 onConfirm 回调函数
  if (props.onConfirm) {
    props.onConfirm()
  }
}
</script>

<style lang="less" scoped>
.update-tips {
  position: absolute;
  top: 50%;
  left: 50%;
  box-sizing: border-box;
  width: 311px;
  border-radius: 16px;
  transform: translate(-50%, -50%);
  background: #f6ebff;
  &__mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    background: rgba(0, 0, 0, 0.6);
  }

  &__title {
    font-size: 24px;
    padding: 16px;
    line-height: 29px;
    color: #323233;
    text-align: center;
    font-family: Alimama ShuHeiTi;
    font-weight: bold;
  }
  &__content {
    padding: 12px 16px;
    background: #ffffff;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  &__memo {
    margin-bottom: 12px;
    font-size: 14px;
    line-height: 20px;
    color: #323233;
  }

  &__warnning {
    padding: 12px;
    margin-bottom: 12px;
    font-size: 12px;
    line-height: 16px;
    color: #646566;
    background-color: #f7f8fa;
    border-radius: 8px;
  }

  &__button {
    width: 100%;
    height: 36px;
    font-size: 14px;
    line-height: 36px;
    color: #ffffff;
    text-align: center;
    background-color: #7a52f4;
    border-radius: 64px;
  }
}
</style>
